import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './long-loading.component.html',
  standalone: false,
})
export class LongLoadingComponent {
  @Input() message: string = 'Loading...';
}
